import { TermsOfServiceModal } from "components/TermsOfService/TermsOfServiceModal";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useGetCurrentTermsOfServiceQuery } from "store/apis/termsOfService";

export const TermsOfServiceGate = () => {
  const { isCustomer } = useRoleBasedView();

  const { data: termsOfService } = useGetCurrentTermsOfServiceQuery(undefined, {
    skip: !isCustomer,
  });

  if (!termsOfService || termsOfService.is_accepted) {
    return null;
  }

  return <TermsOfServiceModal termsOfService={termsOfService} />;
};
